import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SuiTypography from "components/SuiTypography";

function NoAccess() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiTypography variant="h5" fontWeight="medium" textAlign="center" mt={6}>
        You don&apos;t have access to any section yet. Ask a Super Admin to update your role.
      </SuiTypography>
    </DashboardLayout>
  );
}

export default NoAccess;
